// extracted by mini-css-extract-plugin
export default {"userLink":"userLink_userLink__sW8uE"};